import React from 'react';
import { App } from './App';
import { ApolloProvider } from '@apollo/react-hooks';
import client from './client';
import { createRoot } from 'react-dom/client';
import { CssBaseline } from '@mui/material';
const container = document.getElementById('app');
const root = createRoot(container as Element | DocumentFragment);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <CssBaseline />
      <App />
    </ApolloProvider>
  </React.StrictMode>
);
